<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

const props = defineProps({
  as: {
    type: [Object, String],
    default: RouterLink,
  },
  type: {
    type: String,
    default: 'button',
  },
  external: {
    type: Boolean,
    default: false,
  },
  insetFocus: {
    type: Boolean,
    default: false,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  colorClass: {
    type: String,
    default: 'text-brand-blue',
  },
});

const insetFocusClass = computed(() => (props.insetFocus ? 'focus:ring-inset' : 'focus:ring-offset-2'));
const inlineClass = computed(() => (props.inline ? 'inline' : 'inline-flex'));
</script>

<template>
  <Component
    :is="as"
    :type="as === 'button' ? type : null"
    :rel="external ? 'external noopener' : null"
    :target="external ? '_blank' : null"
    :class="[insetFocusClass, inlineClass, colorClass]"
    class="items-center hover:text-brand-blue-light focus:outline-none focus:ring-2 focus:ring-brand-blue disabled:text-gray-400">
    <slot />
  </Component>
</template>
